import { hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import { RENDER_CONTEXT_KEY, type RenderContext } from "./types.ts";

const contextScript = document.getElementById(RENDER_CONTEXT_KEY);
const root = document.getElementById("root");

if (!contextScript?.textContent || !root) {
  throw new Error("CMS render context or #root missing from server HTML");
}

const renderContext: RenderContext = JSON.parse(contextScript.textContent);

hydrateRoot(root, <App renderContext={renderContext} />, {
  onRecoverableError(error) {
    console.error("[cms] hydration error:", error);
  },
});
